@if (isLoading) {
<app-loading-spinner text="Negotiations"> </app-loading-spinner>
} @if (!isLoading) {
<div class="py-2 px-4 page-height main-bg overflow-auto">
  <link
    rel="stylesheet"
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0"
  />
  <div class="my-1 mx-auto max-w-xl text-sm">
    <mat-form-field style="width: 100%" appearance="outline">
      <input
        matInput
        [(ngModel)]="searchFilter"
        placeholder="Search"
        (input)="searchList()"
      />
      <mat-icon
        matSuffix
        class="material-symbols-outlined mx-3 opacity-25 hover:cursor-pointer"
        (click)="searchFilter = ''; searchList()"
      >
        cancel
      </mat-icon>
    </mat-form-field>
    <mat-chip-listbox aria-label="filter selection">
      <mat-chip-option
        class="grey-chip"
        aria-label="Bid"
        (selectionChange)="filterList($event)"
        >Bids</mat-chip-option
      >
      <mat-chip-option
        class="grey-chip"
        aria-label="Offer"
        (selectionChange)="filterList($event)"
        >Offers</mat-chip-option
      >
      <mat-chip-option
        class="grey-chip"
        aria-label="my-negotiations"
        (selectionChange)="filterList($event)"
        >My Negotiations</mat-chip-option
      >
      <mat-chip-option
        class="grey-chip"
        color="primary"
        aria-label="my-bids-offers"
        (selectionChange)="filterList($event)"
        >My Bids/Offers</mat-chip-option
      >
      <mat-chip-option
        class="grey-chip"
        color="warn"
        aria-label="Declined"
        (selectionChange)="filterList($event)"
        >Declined</mat-chip-option
      >
    </mat-chip-listbox>
  </div>
  <div>
    <a>
      @for (item of filteredNegotiations$ | async; track item) {
      <mat-card
        [routerLink]="[item._id]"
        class="cursor-pointer my-card p-4 my-2 mx-auto max-w-xl"
        MatRipple
      >
        <div class="flex justify-between items-center pb-1">
          <div class="text-lg font-medium">
            {{ item.commodity }}
            @if (item.product_type) { - {{ item.product_type }} }-
            {{ item.grade }}
          </div>
          <!-- labels  -->
          <mat-chip-set class="flex flex-row pl-2 items-start text-xs">
            @if (item.status == 'Declined') {
            <mat-chip-option
              aria-label="sent-counter"
              disableRipple="true"
              class="text-xs red-chip p-0"
              >Declined
            </mat-chip-option>
            } @if (userDetails._id == item.lot_user_id) {
            <mat-chip-option
              aria-label="sent-counter"
              disableRipple="true"
              class="text-xs bg-custom-blue purple-chip p-0"
              >My
            </mat-chip-option>
            }
            <mat-chip-option
              style="margin-left: 4px !important"
              disableRipple="true"
              [ngClass]="{
                'blue-chip': item.lot_type === 'Offer',
                'green-chip': item.lot_type === 'Bid'
              }"
            >
              {{ item.lot_type }}
            </mat-chip-option>
          </mat-chip-set>
        </div>
        <div class="flex justify-between items-center">
          @if (isSameYear(item)) {
          <div class="text-sm">
            {{ item.ship_begin_orig | date : "MMM d" : "UTC" }} -
            {{ item.ship_end_orig | date : "MMM d, y" : "UTC" }}
          </div>
          } @if (!isSameYear(item)) {
          <div class="text-sm">
            {{ item.ship_begin_orig | date : "MMM d, y" : "UTC" }} -
            {{ item.ship_end_orig | date : "MMM d, y" : "UTC" }}
          </div>
          }
          <div class="text-sm font-medium">
            {{ item.volume_value_orig }}
            {{ item.units == "Metric Tonnes" ? "MT" : item.units }}
          </div>
        </div>
        <div class="flex justify-between items-center">
          <div class="text-sm">
            {{ item.destination }} ({{ item.delivery_type }})
          </div>
          <div class="text-sm font-medium">
            {{ item.currency == "Canadian Dollars" ? "CAD $" : item.currency }}
            ${{ item.price_value_orig | priceType }} /
            {{ item.units }}
          </div>
        </div>
      </mat-card>
      }
    </a>
  </div>
</div>
}
